import Resource from '@/api/Resource';

export default class Slide extends Resource {
  $name = 'slides';

  $defaults() {
    return {
      id: null,
      title: '',
      image: null,
      thumbnail: null,
      order: 1,
    };
  }
}
